/**
 * +field: world HUD widgets (docs/design/zones.md Phase 1), registered in hud/widgets.ts. They
 * read world/fieldView.ts (written by world/worldApp.ts) and hide themselves outside a world
 * session, so a plain M+ key looks exactly as before.
 *
 *   xpBar        bottom edge     segmented XP bar, level-up rollover
 *   questTracker right          map + band, intro-chain step, accepted bounties (replaces the
 *                               keystone tracker while a world session runs)
 *   auto         bottomCenter   Auto toggle (Z) + pulsing AUTO badge
 *   npcPrompt    screen         "[T] Talk to …" next to a town NPC
 *   waypoint     screen         main-quest beacon / screen-edge arrow
 *   celebrate    screen         LEVEL UP! banner, bounty / dungeon banners, "+Level" float
 */
import type { HudWidgetDef } from '../widgets';
import { FieldXpBar } from './xpBar';
import { QuestTracker } from './questTracker';
import { AutoToggle } from './autoToggle';
import { NpcPrompt } from './npcPrompt';
import { Celebrations } from './celebrate';
import { WaypointMarker } from './waypoint';
import { RewardPops } from './rewardPops';
import './field.css';

export const FIELD_WIDGETS: HudWidgetDef[] = [
  { id: 'fieldTracker', region: 'right', create: (host) => new QuestTracker(host) },
  { id: 'auto', region: 'bottomCenter', create: (host) => new AutoToggle(host) },
  {
    id: 'xpBar',
    region: 'bottomCenter',
    create: (host, ctx) => {
      host.remove();
      return new FieldXpBar(ctx.root);
    },
  },
  {
    id: 'npcPrompt',
    region: 'bottomCenter',
    create: (host, ctx) => {
      host.remove();
      return new NpcPrompt(ctx.root);
    },
  },
  {
    id: 'waypoint',
    region: 'bottomCenter',
    create: (host, ctx) => {
      host.remove();
      return new WaypointMarker(ctx.root);
    },
  },
  {
    // Reward pops for every kill / pickup, fields and dungeons alike (not hidden outside the world).
    id: 'rewardPops',
    region: 'bottomCenter',
    create: (host, ctx) => {
      host.remove();
      return new RewardPops(ctx.root);
    },
  },
  {
    id: 'celebrate',
    region: 'bottomCenter',
    create: (host, ctx) => {
      host.remove();
      return new Celebrations(ctx.root);
    },
  },
];

export { celebrations } from './celebrate';
export { rewardPops } from './rewardPops';
export { openTownPanel, closeTownPanel, townPanelOpen } from './townPanel';
